import { z } from 'zod';
import { DateTime } from 'luxon';
import { StartDateBeforeEndDateRule } from '../../../dynamic-form.types';

export const applyStartDateBeforeEndateOrderSchema = (
  schema: z.ZodTypeAny,
  rule: StartDateBeforeEndDateRule
) => {
  const errorMessage = rule.copy;

  return schema.refine(
    (data: Record<string, unknown>) => {
      const startValue = data[rule.start];
      const endValue = data[rule.end];

      if (!startValue || !endValue || startValue === '' || endValue === '') {
        return true;
      }

      const startDate = DateTime.fromISO(startValue as string);
      const endDate = DateTime.fromISO(endValue as string);

      if (!startDate.isValid || !endDate.isValid) {
        return true;
      }

      return startDate <= endDate;
    },
    {
      message: errorMessage,
      path: [rule.end],
    }
  );
};
